import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "device-pause",
  "use": "device-pause-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"device-pause\"><path d=\"M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0zm-1.5 0a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0zm-5.75 2H7a.25.25 0 0 0 .25-.25v-3.5A.25.25 0 0 0 7 6H6a.25.25 0 0 0-.25.25v3.5c0 .138.112.25.25.25h.75zm2.5 0H9a.25.25 0 0 1-.25-.25v-3.5A.25.25 0 0 1 9 6h1a.25.25 0 0 1 .25.25v3.5A.25.25 0 0 1 10 10h-.75z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol